import React from "react";
import YouTube from "react-youtube";
import { Row, Col } from "react-bootstrap";

function YouTubeVideoList() {
  const videoIdsUpcoming = [
    "D6sCbIv4N7Y",
    "FkxNoRIXDPY",
    "aF08WVSvCok",
    "Iefl-PSNp4w",
    "ZNwHepprCQ4",
    "CXBLDC2WGbk",
  ];

  const videoIdsTopRunning = [
    "qfQ4-suh4Pk",
    "wY1V7rEAQ3o",
    "A4CbAkPb468",
    "uESlhtAmOtk",
    "Huskwf_-u0g",
    "94JSi0JyWfk",
  ];

  const opts = {
    width: "100%",
    height: "200",
    playerVars: {
      autoplay: 0,
      rel: 0,
      modestbranding: 1,
    },
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Top Running Films */}
      <h4>Top Running Films</h4>
      <Row className="g-3">
        {videoIdsTopRunning.map((videoId) => (
          <Col xs={12} sm={6} md={4} key={videoId}>
            <YouTube videoId={videoId} opts={opts} />
          </Col>
        ))}
      </Row>

      {/* Upcoming Films */}
      <h4 className="mt-4">Upcoming Films</h4>
      <Row className="g-3">
        {videoIdsUpcoming.map((videoId) => (
          <Col xs={12} sm={6} md={4} key={videoId}>
            <YouTube videoId={videoId} opts={opts} />
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default YouTubeVideoList;
